export const URL_STATUS_CODE_OUT_OF_LIMIT = 'OUT';
export const URL_STATUS_CODE_TOO_MANY_REDIRECTS = '777';
export const URL_STATUS_CODE_SERVER_DISCONNECTED = '778';
export const URL_STATUS_CODE_TIME_OUT = '444';
export const URL_STATUS_CODE_OK = '200';
export const URL_STATUS_CODE_DNS_RESOLUTION_FAILURE = '599';
export const URL_STATUS_CODE_INTERNAL_ERROR = '888';
export const URL_STATUS_CODE_UNKNOWN_STATUS = "unknown";
export const URL_STATUS_CODE_BAD_REQUEST = '400';
export const URL_STATUS_CODE_UNAUTHORIZED = '401';
export const URL_STATUS_CODE_FORBIDDEN = '403';
export const URL_STATUS_CODE_NOT_FOUND = '404';
export const URL_STATUS_CODE_METHOD_NOT_ALLOWED = '405';
export const URL_STATUS_CODE_NOT_ACCEPTABLE = '406';
export const URL_STATUS_CODE_GONE = '410';
export const URL_STATUS_CODE_TOO_MANY_REQUESTS = '429';
export const URL_STATUS_CODE_NO_RESPONSE = '444';
export const URL_STATUS_CODE_INTERNAL_SERVER_ERROR = '500';
export const URL_STATUS_CODE_BAD_GATEWAY = '502';
export const URL_STATUS_CODE_SERVICE_UNAVAILABLE = '503';
export const URL_STATUS_CODE_LOOP_DETECTED = '508';
export const URL_STATUS_CODE_ORIGIN_IS_UNREACHABLE = '523';
export const URL_STATUS_CODE_SITE_IS_FROZEN = '530';

export const URL_STATUS_OK = "ok"
export const URL_STATUS_DOWN = "down"
export const URL_STATUS_RETRYING = "retrying"

export const DATA_BY_STATUS_CODE = {
    [URL_STATUS_CODE_OUT_OF_LIMIT]: {"SpanishShort": "Fuera de suscripción"},
    [URL_STATUS_CODE_TOO_MANY_REDIRECTS]: {"SpanishShort": "Demasiados redireccionamientos"},
    [URL_STATUS_CODE_SERVER_DISCONNECTED]: {"SpanishShort": "Error interno #174542"},
    [URL_STATUS_CODE_TIME_OUT]: {"SpanishShort": "Tiempo de carga excedido"},
    [URL_STATUS_CODE_OK]: {"SpanishShort": "OK"},
    [URL_STATUS_CODE_DNS_RESOLUTION_FAILURE]: {"SpanishShort": "Falla en resolución DNS"},
    [URL_STATUS_CODE_INTERNAL_ERROR]: {"SpanishShort": "Error interno #074542"},
    [URL_STATUS_CODE_UNKNOWN_STATUS]: {"SpanishShort": "Error desconocido"},
    [URL_STATUS_CODE_BAD_REQUEST]: {"SpanishShort": "Solicitud incorrecta"},
    [URL_STATUS_CODE_UNAUTHORIZED]: {"SpanishShort": "Autenticación necesaria"},
    [URL_STATUS_CODE_FORBIDDEN]: {"SpanishShort": "Acción rechazada"},
    [URL_STATUS_CODE_NOT_FOUND]: {"SpanishShort": "No encontrado"},
    [URL_STATUS_CODE_METHOD_NOT_ALLOWED]: {"SpanishShort": "Método no permitido"},
    [URL_STATUS_CODE_NOT_ACCEPTABLE]: {"SpanishShort": "No aceptable"},
    [URL_STATUS_CODE_GONE]: {"SpanishShort": "Ya no disponible"},
    [URL_STATUS_CODE_TOO_MANY_REQUESTS]: {"SpanishShort": "Demasiadas solicitudes"},
    [URL_STATUS_CODE_NO_RESPONSE]: {"SpanishShort": "Sin respuesta"},
    [URL_STATUS_CODE_INTERNAL_SERVER_ERROR]: {"SpanishShort": "Error interno del servidor"},
    [URL_STATUS_CODE_BAD_GATEWAY]: {"SpanishShort": "Puerta de enlace incorrecta"},
    [URL_STATUS_CODE_SERVICE_UNAVAILABLE]: {"SpanishShort": "Servicio no disponible"},
    [URL_STATUS_CODE_LOOP_DETECTED]: {"SpanishShort": "Bucle infinito detectado"},
    [URL_STATUS_CODE_ORIGIN_IS_UNREACHABLE]: {"SpanishShort": "Origen inalcanzable"},
    [URL_STATUS_CODE_SITE_IS_FROZEN]: {"SpanishShort": "Sitio congelado"}
};
